import Vue from 'vue';

const state = {
  contact : []
};

const getters = {
  contact: state => state.contact,
};

const actions = {


    getContact( {    
        commit,
        dispatch
    }, contactQuery) {
        return new Promise((resolve, reject) => {
          axios.post('/api/contact', contactQuery).then(response => {
            resolve(response)
          }).catch(error => {
            console.log('erreur', error);
          });
        })
      },

};

const mutations = {

};

export default {
  state,
  getters,
  actions,
  mutations,
};